import { render, staticRenderFns } from "./InterventionStatus.vue?vue&type=template&id=224c6810"
import script from "./InterventionStatus.vue?vue&type=script&lang=ts"
export * from "./InterventionStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports